import React from 'react';

const URL_RE = /(https?:\/\/[^\s]+)/g;

export default function LinkifiedText({ text }) {
  if (!text) return null;
  const parts = text.split(URL_RE);
  return parts.map((part, i) =>
    /^https?:\/\//.test(part)
      ? (
        <a
          key={i}
          href={part}
          target="_blank"
          rel="noopener noreferrer"
          onClick={(e) => e.stopPropagation()}
        >
          {part}
        </a>
      )
      : part,
  );
}
